export default "<footer class=\"flex fixed\">\n  <p>{{app_config.footer.copyrightText}}</p>\n</footer>\n"